import React from "react";
import { Col, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { translationConstants } from "../../../constants";

const InputFieldWrapper = ({
  md = 6,
  lg,
  sm,
  label,
  children,
  controlId,
  className,
  isShowTimezone, // New prop
}) => {
  const { t } = useTranslation();
  return (
    <Col md={md} sm={sm} lg={lg} className={className}>
      <Form.Group className="mb-3" controlId={controlId}>
        <Form.Label className="Form-labels">
          {label}
          {isShowTimezone && (
            <span className="timezone-display-text">
              {" "}{t(translationConstants.TIMEZONE_DISPLAY_ON_FIELD)}
            </span>
          )}
        </Form.Label>
        {children}
      </Form.Group>
    </Col>
  );
};

export default InputFieldWrapper;
